import { subscribeChannel, publishChannel } from './channelUtils';

export function sendOperationalMapMode(isOperationalMapMode) {
    
    publishChannel('operational-map-mode-upsert', isOperationalMapMode);

}

export function sendOperationalMapDateRange(payload) {
    
    publishChannel('operational-map-mode-range-upsert', payload);

}

export function sendResetOperationalMapMode() {
    
    publishChannel('operational-map-mode-reset');

}

export function listenOperationalMapMode(callback) {

    return subscribeChannel((event) => {

        const { tipo, payload } = event.data;

        if (
            tipo !== 'operational-map-mode-upsert' &&
            tipo !== 'operational-map-mode-range-upsert' &&
            tipo !== 'operational-map-mode-reset'
        ) {
            return;
        }

        callback({ tipo, payload });

    });

}